import { render, staticRenderFns } from "./createCategoryTemplate.vue?vue&type=template&id=dc8c045a&scoped=true"
import script from "./createCategoryTemplate.vue?vue&type=script&lang=js"
export * from "./createCategoryTemplate.vue?vue&type=script&lang=js"
import style0 from "./createCategoryTemplate.vue?vue&type=style&index=0&id=dc8c045a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8c045a",
  null
  
)

export default component.exports